import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EcoFeeModal from './components/EcoFeeModal';
import { formatPrice } from 'helpers/Price';
import Text from 'components/Text';

export default class EcoFee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEcoFee: null,
        };
    }

    onSelectedEcoFee(selectedEcoFee) {
        this.setState({
            selectedEcoFee,
        });
    }

    render() {
        const { fees, regularPrice } = this.props;
        const { selectedEcoFee } = this.state;

        return (
            <>
                { fees.map((fee, index) => {
                    return (
                        <p key={'fee' + index} className="product__eco_fee">
                            <span className="button--link" onClick={this.onSelectedEcoFee.bind(this, fee)}>
                                <Text textKey="product_eco_fee" />
                                <Text textKey={'product_eco_fee_' + fee.type} />
                            </span> {formatPrice(fee.price)}
                            <EcoFeeModal
                                fee={fee}
                                regularPrice={regularPrice}
                                isOpen={selectedEcoFee === fee}
                                onRequestClose={this.onSelectedEcoFee.bind(this, null)}/>
                        </p>
                    );
                }) }
            </>
        );
    }
}

EcoFee.propTypes = {
    fees: PropTypes.arrayOf(PropTypes.shape({
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        type: PropTypes.string.isRequired,
    })),
    regularPrice: PropTypes.number.isRequired,
};
